export class ParametrosClass {
  Valor: number | string;
  Descricao: string = '';

  constructor() {}
}
